import { oddDeliveryStatus } from 'my-account/constants';
import { ModelBase } from 'store/model-base';

export class FulfillmentDetails extends ModelBase {
    public static storeName: string = 'fulfillmentDetails';

    public carrier: string;
    public fulfillmentState: string;
    public trackingNumber: string;
    public shipmentTrackingUrl: string;
    public returnLabelNumber: string;
    public returnLabelUrl: string;
    public estimatedDeliveryDate: string;
    public shippedDate: string;
    public deliveredDate: string;
    public estimatedShipDate: string;
    public releaseDate: string;
    public deliveryFailedDate: string;
    public target3PL: string;
    public orderPackedDate: string;
    public orderPickedUpDate: string;
    public orderUnpackDate: string;
    public appointmentId: string;
    public oddSubType: string;
    public deliveryStartTime: string;
    public deliveryEndTime: string;
    public oddDeliveryStatus: string;
    public oddTrackingUrl: string;
    public sharedOn: string;
    public expireAt: string;
    public oddOrderCancelReason: string;
    public oddOrderCancelDate: string;
    public isODDStatusPickedUp: boolean;
    public isODDStatusScheduled: boolean;
    public isODDStatusDelivered: boolean;
    public isODDStatusCanceled: boolean;

    public static create<T extends ModelBase>(initData: ApiResponse): T {
        const toReturn: FulfillmentDetails = super.create<FulfillmentDetails>(initData);
        const status: string = initData.oddDeliveryStatus;
        toReturn.isODDStatusPickedUp = status === oddDeliveryStatus.DRIVER_ON_THE_WAY_TO_CUSTOMER ||
            status === oddDeliveryStatus.DRIVER_ARRIVED_AT_DESTINATION;
        toReturn.isODDStatusScheduled = status === oddDeliveryStatus.ORDER_ACCEPTED ||
            status === oddDeliveryStatus.DRIVER_ACCEPTED ||
            status === oddDeliveryStatus.ROUTE_PLAN_UPDATED ||
            status === oddDeliveryStatus.DRIVER_ON_THE_WAY_TO_STORE ||
            status === oddDeliveryStatus.DRIVER_ARRIVED_AT_PICKUP_STORE ||
            status === oddDeliveryStatus.SHARED_LOCATION;
        toReturn.isODDStatusDelivered = status === oddDeliveryStatus.ORDER_DELIVERED;
        toReturn.isODDStatusCanceled = status === oddDeliveryStatus.ODD_ORDER_CANCELLED ||
            status === oddDeliveryStatus.ORDER_NOT_ACCEPTED;

        return super.create<T>(toReturn);
    }
}
